/* eslint-disable */
import { ErrorHelper } from '@/helpers/ErrorHelper';
import { mapGetters, mapActions } from 'vuex';

export const ClientCardDetailsInviteCacheMixin = {
    data() {
        return {
            error: ''
        }
    },
    computed: {
        ...mapGetters('ClientCardDetailsInvites', [
            'findClientCardDetailsInviteCache'
        ]),
        inviteId(){
            console.log('!!!OVERRIDE COMPUTED - inviteId!!!');
        },
        clientCardDetailsInviteCache() {
            return this.findClientCardDetailsInviteCache(this.inviteId);
        },
        clientCardDetailsInvite() {
            return this.clientCardDetailsInviteCache ? this.clientCardDetailsInviteCache.value : null;
        },
        clientCardDetailsInviteStatusId() {
            return this.clientCardDetailsInvite ? this.clientCardDetailsInvite.status.id : null;
        },
        isClientCardDetailsInviteCompleted() {
            return this.clientCardDetailsInvite ? this.clientCardDetailsInvite.completed : false;
        },
        loadingClientCardDetailsInvite() {
            return this.clientCardDetailsInviteCache && this.clientCardDetailsInviteCache.loading;
        }
    },
    watch: {
        inviteId() {
            this.refreshClientCardDetailsInvite();
        }
    },
    methods: {
        ...mapActions('ClientCardDetailsInvites', [
            'fetchClientCardDetailsInvite',
        ]),
        refreshClientCardDetailsInvite() {
            if (!this.clientCardDetailsInviteCache || !!this.clientCardDetailsInviteCache.retry) {
                this.tryFetchClientCardDetailsInvite();
            }
        },
        tryFetchClientCardDetailsInvite() {
            const self = this;
            if (!self.inviteId) {
                return;
            }
            self.error = '';
            self.fetchClientCardDetailsInvite(self.inviteId)
                .catch(error => self.error = ErrorHelper.getError(error));
        }
    },
    created() {
        this.refreshClientCardDetailsInvite();
    }
}
